import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#FFFFFF',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 47"
    >
      <path
        className={classes.path}
        d="M29.1,21.8L29.1,21.8c1.5,0.8,1.5,2.9,0,3.7L2.6,40.8c-0.7,0.4-1.6,0.1-2-0.5c-0.4-0.7-0.3-1.6,0.5-2l25.4-14.7L1.1,8.8c-0.7-0.4-0.9-1.3-0.5-2c0.4-0.7,1.3-0.9,2-0.5L29.1,21.8z"
      />
    </svg>
  );
};
